module.exports = __webpack_public_path__ + "img/Pic_ZS_FPFG.671d5477.png";